import { getLocalStorage } from './functions';
import { isValidArray } from './validations';

/**
 * Branch functions.
 * @module Branches
 */

/**
 * Returns branch ID.
 * @param {Object} currentBranch - Current branch object, including branch ID.
 * @param {Array} showrooms - Array of showroom locations.
 * @returns {object|string|null} - Branch ID as an object or string, or null.
 */
export const getBranchID = (currentBranch, showrooms) => {
	if (isValidArray(currentBranch?.branch_retail)) {
		return currentBranch.branch_retail[0];
	}
	if (getLocalStorage('UserLocation')?.branch_id) {
		return getLocalStorage('UserLocation').branch_id;
	}
	if (showrooms?.[0]?.branch_id) {
		return showrooms[0].branch_id;
	}

	return null;
};

/**
 * Restructure Hours for Structured Data
 * @param {Object} showroom - Showroom data containing hour_sun, hour_mon, hour_tue, hour_wed, hour_thu, hour_fri, hour_sat.
 * @returns {Array} - Array of hours in structured data format.
 */
export const restructureHours = (showroom) => {
	if (!showroom) return [];

	const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	const hourData = [showroom.hour_sun, showroom.hour_mon, showroom.hour_tue, showroom.hour_wed, showroom.hour_thu, showroom.hour_fri, showroom.hour_sat];

	const hoursArray = hourData.map((time, index) => {
		let dayObj = {
			day: daysOfWeek[index],
		};

		let splitTime = time?.split(' - ') || ['Closed', 'Closed'];

		splitTime.forEach((time, index) => {
			if (time.includes('AM')) {
				dayObj[index === 0 ? 'opens' : 'closes'] = time.replace(' AM', '');
			} else if (time.includes('PM')) {
				let newTime = time.replace(' PM', '');
				dayObj[index === 0 ? 'opens' : 'closes'] = `${parseInt(newTime.split(':')[0]) + 12}:00`;
			} else {
				dayObj.description = /appointment/i.test(time) ? 'By appointment only' : 'Closed';
			}
		});

		return dayObj;
	});

	let newHours = [];
	for (let i = 0; i < hoursArray.length; i++) {
		if (newHours.find((hours) => hours.opens === hoursArray[i].opens && hours.closes === hoursArray[i].closes && !hours.description)) {
			newHours.find((hours) => hours.opens === hoursArray[i].opens && hours.closes === hoursArray[i].closes).dayOfWeek.push(hoursArray[i].day);
		} else if (!hoursArray[i].opens && !hoursArray[i].closes && newHours.find((hours) => hours.description === hoursArray[i].description)) {
			newHours.find((hours) => hours.description === hoursArray[i].description).dayOfWeek.push(hoursArray[i].day);
		} else {
			let newObj = {
				'@type': 'OpeningHoursSpecification',
				'dayOfWeek': [hoursArray[i].day],
			};

			if (hoursArray[i].opens) newObj.opens = hoursArray[i].opens;
			if (hoursArray[i].closes) newObj.closes = hoursArray[i].closes;
			if (hoursArray[i].description) newObj.description = hoursArray[i].description;

			newHours.push(newObj);
		}
	}

	return newHours;
};
